import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { Component } from 'intact-vue-next';
import template from './tags.vdt';
import { useNowrap } from './useNowrap';
import { typeDefs as tagTypeDefs } from './base';
import { useChildren } from './useChildren';
import { useDraggable } from './useDraggable';
import { useConfigContext } from '../config';
var typeDefs = {
  nowrap: Boolean,
  draggable: Boolean,
  size: tagTypeDefs.size,
  border: tagTypeDefs.border
};
var defaults = function defaults() {
  return {
    size: 'default',
    border: 'none'
  };
};
var events = {
  dragstart: true,
  dragend: true
};
export var Tags = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tags, _Component);
  function Tags() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.children = useChildren();
    _this.draggable = useDraggable(_this.children);
    _this.nowrap = useNowrap(_this.draggable);
    _this.config = useConfigContext();
    return _this;
  }
  return Tags;
}(Component);
Tags.template = template;
Tags.typeDefs = typeDefs;
Tags.defaults = defaults;
Tags.events = events;